import {
  AddToBagUnavailableIngredient,
  AddToBagUnavailableIngredientsAddAnywayButton,
  AddToBagUnavailableIngredientsBody,
  AddToBagUnavailableIngredientsChooseNewButton,
  AddToBagUnavailableIngredientsContainer,
  AddToBagUnavailableIngredientsContent,
  AddToBagUnavailableIngredientsFooter,
  AddToBagUnavailableIngredientsHeadline,
  AddToBagUnavailableIngredientsList,
} from './components';

export const AddToBagUnavailableIngredients = {
  Container: AddToBagUnavailableIngredientsContainer,
  Content: AddToBagUnavailableIngredientsContent,
  Headline: AddToBagUnavailableIngredientsHeadline,
  Body: AddToBagUnavailableIngredientsBody,
  List: AddToBagUnavailableIngredientsList,
  Ingredient: AddToBagUnavailableIngredient,
  Footer: AddToBagUnavailableIngredientsFooter,
  AddAnywayButton: AddToBagUnavailableIngredientsAddAnywayButton,
  ChooseNewButton: AddToBagUnavailableIngredientsChooseNewButton,
};
